import { useTranslation } from 'react-i18next'
import React from 'react'

export interface IUniversalItemProps<T> {
  data: T
  onClick: () => void
  isSelected?: boolean
  getTitle: (data: T) => string
  getSubtitle?: (data: T) => string
  getDescription?: (data: T) => string
  getImage?: (data: T) => string | null
}

export function UniversalSelectItem<T>({
  data,
  onClick,
  isSelected = false,
  getTitle,
  getSubtitle,
  getDescription,
  getImage,
}: IUniversalItemProps<T>) {
  const { t } = useTranslation()
  const title = getTitle(data)
  const subtitle = getSubtitle?.(data)
  const description = getDescription?.(data)
  const image = getImage?.(data)

  return (
    <div
      className={`millet-item ${isSelected ? 'active' : ''}`}
      onClick={onClick}
    >
      <div
        className="time-category-wrapper"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div>
          {subtitle && (
            <div className="millet-item__subtitle">
              <span>{subtitle}</span>
            </div>
          )}
          <div className="millet-item__title">{title}</div>
          {description && (
            <div className="millet-item__text">
              <span>{description}</span>
            </div>
          )}
        </div>
        <div className="millet-img">
          {image ? (
            <img src={image} alt="" />
          ) : (
            <i className="an-ico an-ico-photo-add" />
          )}
        </div>
      </div>
    </div>
  )
}
